import { informationConstants } from '../_constants/information.constants';

// InFormation
export const fetchFundInfoStart = (data) => ({
	type: informationConstants.FETCH_FUND_INFO_START,
	payload: data
});

export const fetchFundInfoSuccess = (data) => ({
	type: informationConstants.FETCH_FUND_INFO_SUCCESS,
	payload: data
});

export const fetchFundInfoFailure = (errorMessage) => ({
	type: informationConstants.FETCH_FUND_INFO_FAILURE,
	payload: errorMessage
});

export const clearFundInfo = () => ({
	type: informationConstants.CLEAR_FUND_INFO
});

export const updateFundId = (fundCode) => ({
	type: informationConstants.UPDATE_FUND_ID,
	payload: fundCode
});

export const updateRecentTab = (tab) => ({
	type: informationConstants.UPDATE_RECENT_TAB,
	payload: tab
});

export const fetchTradingInformationStart = (data) => ({
	type: informationConstants.FETCH_TRADING_INFO_START,
	payload: data
});

export const fetchTradingInformationSuccess = (data) => ({
	type: informationConstants.FETCH_TRADING_INFO_SUCCESS,
	payload: data
});

export const fetchTradingInformationFailure = (errorMessage) => ({
	type: informationConstants.FETCH_TRADING_INFO_FAILURE,
	payload: errorMessage
});

export const fetchPortfolioInformationStart = (fundId) => ({
	type: informationConstants.FETCH_PORTFOLIO_INFO_START,
	payload: fundId
});

export const fetchPortfolioInformationSuccess = (data) => ({
	type: informationConstants.FETCH_PORTFOLIO_INFO_SUCCESS,
	payload: data
});

export const fetchPortfolioInformationFailure = (errorMessage) => ({
	type: informationConstants.FETCH_PORTFOLIO_INFO_FAILURE,
	payload: errorMessage
});

export const fetchFundAverageRatingStart = (data) => ({
	type: informationConstants.FETCH_FUND_AVERAGE_RATING_START,
	payload: data
});

export const fetchFundAverageRatingSuccess = (data) => ({
	type: informationConstants.FETCH_FUND_AVERAGE_RATING_SUCCESS,
	payload: data
});

export const fetchFundAverageRatingFailure = (errorMessage) => ({
	type: informationConstants.FETCH_FUND_AVERAGE_RATING_FAILURE,
	payload: errorMessage
});

export const voteFundAverageRating = (data) => ({
	type: informationConstants.VOTE_FUND_AVERAGE_RATING,
	payload: data
});

export const fetchCalendarFundStart = (data) => ({
	type: informationConstants.FETCH_CALENDAR_FUND_START,
	payload: data
});

export const fetchCalendarFundSuccess = (data) => ({
	type: informationConstants.FETCH_CALENDAR_FUND_SUCCESS,
	payload: data
});

export const fetchCalendarFundFailure = (errorMessage) => ({
	type: informationConstants.FETCH_CALENDAR_FUND_FAILURE,
	payload: errorMessage
});

// Port Info
export const fetchFundPortInfoStart = (fundId) => ({
	type: informationConstants.FETCH_FUND_PORT_INFO_START,
	payload: fundId
});

export const fetchFundPortInfoSuccess = (data) => ({
	type: informationConstants.FETCH_FUND_PORT_INFO_SUCCESS,
	payload: data
});

export const fetchFundPortInfoFailure = (errorMessage) => ({
	type: informationConstants.FETCH_FUND_PORT_INFO_FAILURE,
	payload: errorMessage
});

export const fetchFundPortChartByChartTypeStart = (fundId) => ({
	type: informationConstants.FETCH_FUND_PORT_CHART_BY_CHART_TYPE_START,
	payload: fundId
});

export const fetchFundPortChartByChartTypeSuccess = (data) => ({
	type: informationConstants.FETCH_FUND_PORT_CHART_BY_CHART_TYPE_SUCCESS,
	payload: data
});

export const fetchFundPortChartByChartTypeFailure = (errorMessage) => ({
	type: informationConstants.FETCH_FUND_PORT_CHART_BY_CHART_TYPE_FAILURE,
	payload: errorMessage
});

// Statistic
export const fetchWeeklyFundRankingStart = (data) => ({
	type: informationConstants.FETCH_WEEKLY_FUND_RANKING_START,
	payload: data
});

export const fetchWeeklyFundRankingSuccess = (data) => ({
	type: informationConstants.FETCH_WEEKLY_FUND_RANKING_SUCCESS,
	payload: data
});

export const fetchWeeklyFundRankingFailure = (errorMessage) => ({
	type: informationConstants.FETCH_WEEKLY_FUND_RANKING_FAILURE,
	payload: errorMessage
});

export const fetchDrawdownByDateStart = (data) => ({
	type: informationConstants.FETCH_DRAWDOWN_BY_DATE_START,
	payload: data
});

export const fetchDrawdownByDateSuccess = (data) => ({
	type: informationConstants.FETCH_DRAWDOWN_BY_DATE_SUCCESS,
	payload: data
});

export const fetchDrawdownByDateFailure = (errorMessage) => ({
	type: informationConstants.FETCH_DRAWDOWN_BY_DATE_FAILURE,
	payload: errorMessage
});

export const fetchMaximumDrawdownStart = (data) => ({
	type: informationConstants.FETCH_MAXIMUM_DRAWDOWN_START,
	payload: data
});

export const fetchMaximumDrawdownSuccess = (data) => ({
	type: informationConstants.FETCH_MAXIMUM_DRAWDOWN_SUCCESS,
	payload: data
});

export const fetchMaximumDrawdownFailure = (errorMessage) => ({
	type: informationConstants.FETCH_MAXIMUM_DRAWDOWN_FAILURE,
	payload: errorMessage
});

export const fetchDrawdownNavGraphStart = (data) => ({
	type: informationConstants.FETCH_DRAWDOWN_NAV_GRAPH_START,
	payload: data
});

export const fetchDrawdownNavGraphSuccess = (data) => ({
	type: informationConstants.FETCH_DRAWDOWN_NAV_GRAPH_SUCCESS,
	payload: data
});

export const fetchDrawdownNavGraphFailure = (errorMessage) => ({
	type: informationConstants.FETCH_DRAWDOWN_NAV_GRAPH_FAILURE,
	payload: errorMessage
});

export const changeDrawdownStatisticFilters = (data) => ({
	type: informationConstants.CHANGE_DRAWDOWN_STATISTIC_FILTERS,
	payload: data
});

export const changeNavGraphDate = (date) => ({
	type: informationConstants.CHANGE_NAV_GRAPH_DATE,
	payload: date
});

export const changeSortedDrawdown = (date) => ({
	type: informationConstants.CHANGE_SORTED_DRAWDOWN,
	payload: date
});

export const fetchMonthlyReturnStart = (data) => ({
	type: informationConstants.FETCH_MONTHLY_RETURN_START,
	payload: data
});

export const fetchMonthlyReturnSuccess = (data) => ({
	type: informationConstants.FETCH_MONTHLY_RETURN_SUCCESS,
	payload: data
});

export const fetchMonthlyReturnFailure = (errorMessage) => ({
	type: informationConstants.FETCH_MONTHLY_RETURN_FAILURE,
	payload: errorMessage
});

export const fetchPriceRangeStart = (data) => ({
	type: informationConstants.FETCH_PRICE_RANGE_START,
	payload: data
});

export const fetchPriceRangeSuccess = (data) => ({
	type: informationConstants.FETCH_PRICE_RANGE_SUCCESS,
	payload: data
});

export const fetchPriceRangeFailure = (errorMessage) => ({
	type: informationConstants.FETCH_PRICE_RANGE_FAILURE,
	payload: errorMessage
});

export const fetchVolatilitiesStart = (data) => ({
	type: informationConstants.FETCH_VOLATILITIES_START,
	payload: data
});

export const fetchVolatilitiesSuccess = (data) => ({
	type: informationConstants.FETCH_VOLATILITIES_SUCCESS,
	payload: data
});

export const fetchVolatilitiesFailure = (errorMessage) => ({
	type: informationConstants.FETCH_VOLATILITIES_FAILURE,
	payload: errorMessage
});

export const fetchReturnExpenseRatioStart = (data) => ({
	type: informationConstants.FETCH_RETURN_EXPENSE_RATIO_START,
	payload: data
});

export const fetchReturnExpenseRatioSuccess = (data) => ({
	type: informationConstants.FETCH_RETURN_EXPENSE_RATIO_SUCCESS,
	payload: data
});

export const fetchReturnExpenseRatioFailure = (errorMessage) => ({
	type: informationConstants.FETCH_RETURN_EXPENSE_RATIO_FAILURE,
	payload: errorMessage
});

export const fetchMonthlyProfitStart = (data) => ({
	type: informationConstants.FETCH_MONTHLY_PROFIT_START,
	payload: data
});

export const fetchMonthlyProfitSuccess = (data) => ({
	type: informationConstants.FETCH_MONTHLY_PROFIT_SUCCESS,
	payload: data
});

export const fetchMonthlyProfitFailure = (errorMessage) => ({
	type: informationConstants.FETCH_MONTHLY_PROFIT_FAILURE,
	payload: errorMessage
});

export const fetchReturnHistoryStart = (data) => ({
	type: informationConstants.FETCH_RETURN_HISTORY_START,
	payload: data
});

export const fetchReturnHistorySuccess = (data) => ({
	type: informationConstants.FETCH_RETURN_HISTORY_SUCCESS,
	payload: data
});

export const fetchReturnHistoryFailure = (errorMessage) => ({
	type: informationConstants.FETCH_RETURN_HISTORY_FAILURE,
	payload: errorMessage
});

// HistoricalNav
export const fetchHistoricalNavStart = (data) => ({
	type: informationConstants.FETCH_HISTORICAL_NAV_START,
	payload: data
});

export const fetchHistoricalNavSuccess = (data) => ({
	type: informationConstants.FETCH_HISTORICAL_NAV_SUCCESS,
	payload: data
});

export const fetchHistoricalNavFailure = (errorMessage) => ({
	type: informationConstants.FETCH_HISTORICAL_NAV_FAILURE,
	payload: errorMessage
});

// HistoryNav Graph
export const fetchHistoricalNavGraphStart = (data) => ({
	type: informationConstants.FETCH_HISTORICAL_NAV_GRAPH_START,
	payload: data
});

export const fetchHistoricalNavGraphSuccess = (data) => ({
	type: informationConstants.FETCH_HISTORICAL_NAV_GRAPH_SUCCESS,
	payload: data
});

export const fetchHistoricalNavGraphFailure = (errorMessage) => ({
	type: informationConstants.FETCH_HISTORICAL_NAV_GRAPH_FAILURE,
	payload: errorMessage
});

// Dividend
export const fetchDividendStart = (data) => ({
	type: informationConstants.FETCH_DIVIDEND_START,
	payload: data
});

export const fetchDividendSuccess = (data) => ({
	type: informationConstants.FETCH_DIVIDEND_SUCCESS,
	payload: data
});

export const fetchDividendFailure = (errorMessage) => ({
	type: informationConstants.FETCH_DIVIDEND_FAILURE,
	payload: errorMessage
});

export const fetchDividendGroupByYearStart = (fundId) => ({
	type: informationConstants.FETCH_DIVIDEND_GROUP_BY_YEAR_START,
	payload: fundId
});

export const fetchDividendGroupByYearSuccess = (data) => ({
	type: informationConstants.FETCH_DIVIDEND_GROUP_BY_YEAR_SUCCESS,
	payload: data
});

export const fetchDividendGroupByYearFailure = (errorMessage) => ({
	type: informationConstants.FETCH_DIVIDEND_GROUP_BY_YEAR_FAILURE,
	payload: errorMessage
});

export const fetchDividendDescriptionStart = (fundId) => ({
	type: informationConstants.FETCH_DIVIDEND_DESCRIPTION_START,
	payload: fundId
});

export const fetchDividendDescriptionSuccess = (data) => ({
	type: informationConstants.FETCH_DIVIDEND_DESCRIPTION_SUCCESS,
	payload: data
});

export const fetchDividendDescriptionFailure = (errorMessage) => ({
	type: informationConstants.FETCH_DIVIDEND_DESCRIPTION_FAILURE,
	payload: errorMessage
});

// Change Active Button
export const fetchChangeActiveBtn = (index) => ({
	type: informationConstants.FETCH_CHANGE_ACTIVE_BTN,
	payload: index
});

// Change Page
export const changeHistoricalNavPage = (page) => ({
	type: informationConstants.FETCH_HISTORICAL_NAV_CHANGE_PAGE,
	payload: page
});

export const changeDividendPage = (page) => ({
	type: informationConstants.FETCH_DIVIDEND_CHANGE_PAGE,
	payload: page
});

// export const insertScrollPosition = (position) => ({
// 	type: informationConstants.INSERT_SCROLL_POSITION,
// 	payload: position
// });